import React from 'react'
import UploadForm from '../components/UploadForm/UploadForm'

const Photos = () => {
    return (
        <div className="container sec1 flex">
            <div className="main">
                <UploadForm/>
            </div>
        </div>
    )
}

export default Photos;